import { canonicalize } from "json-canonicalize";
import { getInitialConfig, getModifiedConfig } from "./checksumStore";
import { diff } from "jsondiffpatch";

export const hasConfigChanged = () => {
  return hasChanged(getInitialConfig(), getModifiedConfig());
};

export const hasChangedComparedToModified = (config) => {
  return hasChanged(config, getModifiedConfig());
};

export const hasChanged = (initialConfig, currentConfig) => {
  try {
    const isEmpty = (val) =>
      val == null ||
      (Array.isArray(val) && val.length === 0) ||
      (typeof val === "object" && !Array.isArray(val) && Object.keys(val).length === 0);

    if (isEmpty(initialConfig) || isEmpty(currentConfig)) {
      return false;
    }

    const preparedInitial = prepareConfigForComparison(initialConfig);
    const preparedCurrent = prepareConfigForComparison(currentConfig);

    const isDiffFound = diff(preparedInitial, preparedCurrent);

    if (isDiffFound) {
      console.log("isDiffFound", isDiffFound);
      return true;
    }

    return false;
  } catch (error) {
    console.error("Error in hasChanged:", error);
    return false;
  }
};

const prepareConfigForComparison = (config) => {
  const clean = JSON.parse(JSON.stringify(config));

  const keysToSkipSorting = ["menu", "menu_bottom", "fields", "columns"];

  const strip = (obj, parentKey = null) => {
    if (Array.isArray(obj)) {
      const strippedArray = obj.map((item) => strip(item, null)).filter(Boolean); // remove falsy items in array

      return keysToSkipSorting.includes(parentKey)
        ? strippedArray
        : strippedArray.sort((a, b) => canonicalize(a).localeCompare(canonicalize(b)));
    }

    if (typeof obj === "object" && obj !== null) {
      const result = {};
      Object.keys(obj).forEach((key) => {
        const value = strip(obj[key], key);
        if (
          !["id", "selected", "chosen", "createdAt", "updatedAt"].includes(key) &&
          Boolean(value) // Skip falsy values
        ) {
          result[key] = value;
        }
      });
      return result;
    }

    return obj;
  };

  return strip(clean);
};
